import React from 'react';
import { useState } from "react";
import { InputMasks } from '@/components/shadcn/ui/input';
import { useBusiness } from '@/hook/useBusiness';
import { useEmail } from '@/hook/useEmail';
import logo from './logo/logoNext.png';
import { toast } from '@/components/shadcn/ui/use-toast';
import { useWhatsapp } from '@/hook/useWhatsapp';


export default function Demo() {
  const { createClientBusiness } = useBusiness();
  const { sendEmailCliente } = useEmail()
  const [produto, setProduto] = useState("");
  const [nome, setNome] = useState("");
  const [telefone, setTelefone] = useState("");
  const [atividade, setAtividade] = useState("")
  const [email, setEmail] = useState("");  
  const {sendWhatsapp} = useWhatsapp();

  const emailsend = {
    nome: nome,
    telefone: telefone,
    atividade: atividade,
    email: email,
  }
  const onAddItem = () => {
    if (nome != '' && atividade != '' && email != '' && telefone != '') {
      const response = createClientBusiness({
        description: nome,
        opportunityFlowId: 1,
        email: email,
        observation: `tipo de atividade: ${atividade}, e está com interesse no produto ${produto}`,
        contactNumber: telefone
      });
      const response3 = sendWhatsapp();
      const response2 = sendEmailCliente(emailsend);
      toast({
        description: 'Email enviado com sucesso'
      })
      if (!response) return;
      if (!response2) {toast({description:'ocorreu um erro ao enviar o email'})}
      if (!response3) return;
    }
    else {
      toast({
        description: 'preencha do campos indicado por *'
      })
    }

  }

  return (
    <div>
      <div className="flex md:flex-row justify-between bg-[url('/logo/background.jpg')] bg-no-repeat bg-cover bg-bottom lg:h-screen sm:w-[100%] h-auto flex-col " >
        <div className="m-10 flex justify-items-center items-center flex-col md:flex-row">
          <div className='lg:h-screen'>
            <a href="https://www.nextcompany.com.br/" className="p-0 rounded-full md: m-3">
              <img src={logo} alt="logo nextcompany" className='w-[100px] h-[50px]' />
            </a>
          </div>
          <h2 className="sm:text-xl font-bold mb-2 ml-4 text-cyan-600">Agende sua demonstração.</h2>
        </div>
        <div className="flex overflow-x-auto justify-center lg:h-[95%] flex-col bg-white shadow-xl p-4 rounded-lg sm:h-[150%] lg:w-3/6 mt-2 ml-6 mr-5  ">
          <label className="block text-sm font-medium mt-2">Seu nome * :</label>
          <input required type="text" className="lg:w-full p-2 border rounded mb-3" value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Digite seu Nome" />

          <label className="block text-sm font-medium">Telefone * :</label>
          <InputMasks required mask="(99) 99999-9999" type="tel" pattern="[0-9]*" value={telefone} onChange={(e: { target: { value: React.SetStateAction<string>; }; }) => setTelefone(e.target.value)} className="lg:w-2/5 p-2 border rounded mb-3 md:w-3/5" placeholder="Digite seu número de telefone" />

          <label className="block text-sm font-medium">Tipo atividade * : </label>
          <input required type="text" className="lg:w-full p-2 border rounded mb-3" value={atividade} onChange={(e) => setAtividade(e.target.value)} placeholder="Digite o tipo de atividade de sua empresa" />

          <label className="block text-sm font-medium">Email * : </label>
          <input required type="text" className="lg:w-full p-2 border rounded mb-3" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Digite seu Email" />

            <div className="flex">
            <div className="flex flex-col lg:w-full w-2/3">
              <label className="block text-sm font-medium">Produto: </label>
              <select
                className="lg:w-full p-2 border rounded mb-3"
                value={produto}
                onChange={(e) => setProduto(e.target.value)}
              >
                <option value="">Selecione Produto</option>
                <option value="iCompany">iCompany</option>
                <option value="wCompany">wCompany</option>
                <option value="xPDV">xPDV</option>
                <option value="smartPDV">smartPDV</option>
                <option value="ipdv">ipdv</option>
                <option value="wCarte">wCarte</option>
                <option value="NextBI">NextBI</option>
              </select>
            </div>
          </div>
          <button onClick={onAddItem} className="lg:w-full bg-blue-500 text-white p-2 rounded mt-2">Enviar</button>
        </div>
      </div>
    </div>
  );
}